module.exports = __webpack_public_path__ + "static/media/count25_326.73740370.png";